import { applyMiddleware, combineReducers, createStore, Reducer } from "redux";

import createSagaMiddleware, { SagaMiddleware } from "redux-saga";
import auth from "../redux/auth/authReducer";
import { SOCKETS_URL } from "../redux/Consts";
import devicesReducer from "../redux/devices/devicesReducer";
import devicesStatusesReducer from "../redux/devicesStatuses/devicesStatusesReducer";
import healthCheckReducer from "../redux/healthCheck/healthCheckReducer";
import feedbackReducer from "../redux/modalFeedback/feedbackReducer";
import monitorAlertsReducer from "../redux/alerts/alertReducer";
import repeatAlertReducer from "../redux/repeatAlert/repeatAlertReducer";
import preloaderReducer from "../redux/preloader/preloaderReducer";
import residentsReducer from "../redux/residents/residentsReducer";
import residentStatusesReducer from "../redux/residentStatuses/residentStatusesReducer";
import notificationReducer from "../redux/newNotification/notificationReducer";
import { IAppState } from "../redux/types";
import userProfileReducer from "../redux/userProfile/userProfileReducer";
import organizationReducer from "../redux/organization/organizationReducer";
import usersReducer from "../redux/users/usersReducer";
import residentActivityPlanReducer from "../redux/residentActivityPlan/residentActivityPlanReducer";
import userActivityReducer from "../redux/userActivity/userActivityReducer";
import { socketMiddleware } from "../sockets/socketMiddleware";
import rootSaga from "./rootSaga";
const sagaMiddleware: SagaMiddleware = createSagaMiddleware();

const reducers: Reducer<IAppState> = combineReducers<IAppState>({
  auth,
  alerts: monitorAlertsReducer,
  devices: devicesReducer,
  userProfile: userProfileReducer,
  notification: notificationReducer,
  preloader: preloaderReducer,
  residents: residentsReducer,
  feedback: feedbackReducer,
  residentStatuses: residentStatusesReducer,
  devicesStatuses: devicesStatusesReducer,
  repeatAlert: repeatAlertReducer,
  healthCheck: healthCheckReducer,
  organization: organizationReducer,
  users: usersReducer,
  residentActivityPlan: residentActivityPlanReducer,
  userActivity: userActivityReducer,
});

const rootReducer = (state: IAppState, action: any) => {
  // if (action.type === AUTHENTICATION.LOGOUT_NEW_SUCCESS) {
  //     //storage.removeItem('persist:root');
  //     state = undefined;
  // }

  return reducers(state, action);
};

//const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore() {
  let middleware = applyMiddleware(
    sagaMiddleware,
    socketMiddleware(SOCKETS_URL())
  );

  const store = createStore(rootReducer, undefined, middleware);
  sagaMiddleware.run(rootSaga);
  //  const persistor = persistStore(store);

  return { store };
}
